import * as go from 'gojs';
import * as _ from 'lodash/fp';

import { minDistance, tokensAmount } from '@process-advisor/process-miner/processMiner/animateLifecycleVariant/consts';

export const getNewTokensShowingPoints = (
    links: { link: go.Link, length: number }[],
) => {
    const pathLength = _.sumBy('length')(links);
    const breaks = Math.max(pathLength / tokensAmount, minDistance);
    let newPoints = [{ distance: 0, frac: 0 }];

    links
        .map(({ length }) => length)
        .reduce((sum: number, newLength: number, idx: number) => {
            if (sum + newLength >= _.last(newPoints).distance) {
                const pointsToCreate = Math.floor((sum + newLength) / breaks)
                    - newPoints.length + 1;
                _.forEach(() => {
                    const lastPoint = _.last(newPoints);
                    newPoints = [
                        ...newPoints,
                        {
                            frac: idx + (lastPoint.distance + breaks - sum) / newLength,
                            distance: lastPoint.distance + breaks,
                        },
                    ];
                })(_.range(0, pointsToCreate));
            }

            return sum + newLength;
        }, 0);

    return _.initial(_.tail(newPoints));
};
